module.exports = __webpack_public_path__ + "media/images/icons/location_bis-1fcb0891b97f390864c4e63b2def1f5d.svg";